import { pink, red } from "@material-ui/core/colors";

const styles = theme => ({
    root: {
        flexGrow: 1
    },
    grow: {
        flexGrow: 1,
    },
    main: {

    },
    adminMenuContainer: {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        padding: "25px",
        minHeight: "800px",
    }
});

export default styles;
